module.exports = __webpack_public_path__ + "img/kebab-24px.0ad865d1.svg";